import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  Link,
} from "@mui/material";
import { PRIMARY_PINK } from "../../constants";

function ForgotPasswordModal({ open, onClose, onResetPassword, onSwitchToSignIn }) {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onResetPassword({ email });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
        <Typography variant="h5" component="div">
          Forgot Password
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Enter your email address and we&apos;ll send you a link to reset your password.
          </Typography>
          
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          
          <Box sx={{ mt: 2, textAlign: "center" }}>
            <Typography variant="body2" color="text.secondary">
              Remember your password?{" "}
              <Link
                component="button"
                variant="body2"
                onClick={onSwitchToSignIn}
                sx={{ 
                  cursor: "pointer",
                  color: PRIMARY_PINK,
                  fontWeight: 500,
                  "&:hover": {
                    color: "#1565c0"
                  }
                }}
              >
                Sign in
              </Link>
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          onClick={onClose} 
          fullWidth 
          variant="outlined"
          sx={{
            color: "#000000",
            borderColor: "#000000",
            fontWeight: 600,
            fontSize: "1rem",
            textTransform: "none",
            "&:hover": {
              borderColor: "#000000",
              backgroundColor: "rgba(0,0,0,0.08)"
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          fullWidth 
          variant="contained"
          sx={{
            bgcolor: "#000000",
            color: "#FFFFFF",
            fontWeight: 600,
            fontSize: "1rem",
            textTransform: "none",
            "&:hover": {
              bgcolor: "#333333"
            }
          }}
        >
          Send Reset Link
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ForgotPasswordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired,
  onSwitchToSignIn: PropTypes.func.isRequired,
};

export default ForgotPasswordModal; 